import { render, staticRenderFns } from "./choosevideo.vue?vue&type=template&id=3673dc97&scoped=true"
import script from "./choosevideo.vue?vue&type=script&lang=js"
export * from "./choosevideo.vue?vue&type=script&lang=js"
import style0 from "./choosevideo.vue?vue&type=style&index=0&id=3673dc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673dc97",
  null
  
)

export default component.exports